export enum BannerType {
  SHOPIFY_OPTIONS_INFO_BANNER = 'SHOPIFY_OPTIONS_INFO_BANNER',
  TEXT_PERSONALIZATION_PROMOTION_BANNER = 'TEXT_PERSONALIZATION_PROMOTION_BANNER',
  IMAGE_PERSONALIZATION_PROMOTION_BANNER = 'IMAGE_PERSONALIZATION_PROMOTION_BANNER',
}
